import { push } from "connected-react-router";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  APPLICATION_MODE_NEW,
  ROUTE_PATH,
} from "../../../app/constants";
import { ERROR_STRING } from "../../../app/errors";
import {applicationTypeFromLicenceSubType} from '../../../redux/slice/applicationsUtils'
import { ErrorMark } from "../../../components/RegularComponents";
import { saveBusinessLicenceApplicationData } from "../../../redux/slice/businessLicenceApplicationSlice";
import {
  LICENCED_EXEMPT,
  LICENCED_UNDER_BROKERAGE,
} from "../../../redux/slice/primaryAgencyApplicationSlice";
import styles from "../mra.module.scss";
import TopNavigationBar from "../../TopNavigationBar";
import { usePathApplication } from "../../../redux/hooks/usePathApplication";
import { setMortgageProperty } from "../../../redux/slice/primaryAgencyApplicationSlice";
import { agencyApplicationSelector } from "../../../redux/selector/agencyApplicationSelector";

export const LicenceTypeSelectionView = (props) => {
  const { isModal = false, onEditSave = () => {} } = props;
  const dispatch = useDispatch();
  const { application } = usePathApplication();
  // const isPrincipalBroker =  (ROUTE_PATH.PB_APP.search(application) !== -1);
  const {agencyApplication} = useSelector(agencyApplicationSelector) || {};
  const licencingSubType = agencyApplication?.licencingSubType;
  const applicationType = applicationTypeFromLicenceSubType(licencingSubType)
  const applicationMode = APPLICATION_MODE_NEW;

  const [applicationSaveError, setApplicationSaveError] = useState(false);
  const [selectionError, setSelectionError] = useState(false);

  const previouslyLicencedStatus = agencyApplication?.businessLicenceData?.previouslyLicencedStatus ?? null;

  const handleNext = () => {
    setApplicationSaveError(false);

    if(previouslyLicencedStatus === null) {
      setSelectionError(true)
      return
    }

    dispatch(
      saveBusinessLicenceApplicationData(applicationType, applicationMode)
    )
      .then((data) => {
        if (!isModal) {
          if (previouslyLicencedStatus === LICENCED_UNDER_BROKERAGE) {
            dispatch(
              push(`/${application}${ROUTE_PATH.MRA_ADD_MAIN_AGENT_LICENCE_IN_OTHER_PROVINCE}`)
            );
          } else if (previouslyLicencedStatus === LICENCED_EXEMPT) {
            dispatch(
              push(`/${application}${ROUTE_PATH.MRA_ADD_MAIN_AGENT_UPLOAD_WORK_HISTORY}`)
            );
          }
        } else {
          onEditSave();
        }
      })
      .catch((err) => {
        setApplicationSaveError(true);
      });
  };

  const handleChange = (event) => {
    setSelectionError(false)
    const value = event.target.value;
    dispatch(setMortgageProperty({ 
        key: "previouslyLicencedStatus",
        value:value
      })
    )
  };

  return (
    <div className={!isModal ? "container" : ""}>
      {/* Title */}
      {!isModal && (
        <>
         <TopNavigationBar {...props} applicationType={applicationType} applicationMode={applicationMode} />
          <div className="row">
            <div className="col-xs-12 col-lg-8">
              <h1>What type of licence are you applying for?</h1>
              <div className="topMarginMedium bottomMarginMedium">
                Select an option based on your history and type of licence you're applying for.
              </div>
            </div>
          </div>
        </>
      )}
      {/* Information Paragraphs */}
      <div className="row">
        <div className="col-lg-7">
          <fieldset className="ns-fieldset">
            <div className={"ns-radios ns-radios--small"}>
              <div className="ns-radios__item">
                <input
                  className="ns-radios__input"
                  type={"radio"}
                  value={LICENCED_UNDER_BROKERAGE}
                  checked={
                    previouslyLicencedStatus === LICENCED_UNDER_BROKERAGE
                  }
                  onChange={handleChange}
                  id={"mraApplication-licenced-brokerage-type-input"}
                  name={"mraApplication-licenced-brokerage-type-input"}
                />
                <label
                  id={"mraApplication-licenced-brokerage-type-label"}
                  className="ns-radios__label"
                  style={{display: "block"}}
                  htmlFor={"mraApplication-licenced-brokerage-type-input"}
                >
                  <div style={{display: "block", margin: "0px 0px 5px 10px"}}>Mortgage Broker Licence</div>
                </label>
              </div>

              <div className="ns-radios__item">
                <input
                  className="ns-radios__input"
                  type={"radio"}
                  value={LICENCED_EXEMPT}
                  checked={previouslyLicencedStatus === LICENCED_EXEMPT}
                  onChange={handleChange}
                  id={"mraApplication-licenced-exempt-type-input"}
                  name={"mraApplication-licenced-exempt-type-input"}
                />
                <label
                  id={"mraApplication-licenced-exempt-type-label"}
                  className="ns-radios__label"
                  style={{display: "block"}}
                  htmlFor={"mraApplication-licenced-exempt-type-input"}
                >
                  <div style={{display: "block", margin: "0px 0px 5px 10px"}}>Mortgage Broker Licence</div>
                  <span 
                    style={{display: "block", margin: "0px 0px 0px 10px"}}
                    className="bltReviewDecisionInfo">
                      You brokered mortgages for a federally regulated financial institution for at least 24 of the 36 months immediately before the date of their application.
                    </span>
                </label>
              </div>
              
            </div>
          </fieldset>
        </div>
      </div>
      <div className="row">
        <div
          className={"col-lg-8" + ((applicationSaveError || selectionError) ? " has-error" : "")}
        >
          <button
            className={`${styles["question_button"]} btn-lg btn-default`}
            onClick={handleNext}
            name={"Yes"}
          >
            Save and next
          </button>
          {(applicationSaveError || selectionError) && ErrorMark()}
          {applicationSaveError && (
            <div className="ns-error-message help-block topMarginNormal">
              <span className="ns-visually-hidden">Error:</span>
              {ERROR_STRING.APPLICATION_SAVE_ERROR}
            </div>
          )}
          {selectionError && (
            <div className="ns-error-message help-block topMarginNormal">
              <span className="ns-visually-hidden">Error:</span>
              {ERROR_STRING.PREVIOUS_LICENCE_STATUS_NOT_SELECTED}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
